export const PROJECT_PAGES_SPOTLIGHT_KEY = 'spotlight-sidebar-project-pages';
